<template>
  <div class="app-container">
    <el-card class="mb10">
      <el-form label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="8">
            <!--渠道-->
            <el-form-item :label="$t('operationCenter.channel')">
              <el-select
                v-model="queryForm.params.channelValue"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                style="width: 100%;"
                clearable
                filterable
              >
                <el-option
                  v-for="item in channelOption"
                  :key="item.id"
                  :label="item.dictName"
                  :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('collectionCenter.stateZT')">
              <el-select
                v-model="queryForm.params.status"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                style="width: 100%;"
                clearable
                filterable
              >
                <el-option key="1" :label="$t('GlobalSetObj.enable')" :value="1" />
                <el-option key="2" :label="$t('GlobalSetObj.disable')" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div style="margin-top: 28px;">
              <!--查询-->
              <el-button
                type="primary"
                icon="el-icon-search"
                size="mini"
                @click="search"
              >{{ $t('basicData.Search') }}
              </el-button>
              <!--重置-->
              <el-button
                icon="el-icon-refresh"
                size="mini"
                @click="onReset"
              >{{ $t('basicData.reset') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <div style="margin-bottom: 10px;">
        <el-button
          v-permit:remove="'but:finance:basicData:channelVolume:add'"
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="addChannelData()"
        >{{ $t('GlobalSetObj.add') }}
        </el-button>
      </div>
      <tableCmp
        :key="tableKey"
        :table-data="tableData"
        @tableOperate="addChannelData"
        @checkHistory="checkVersion"
        @tableUpdate="tableUpdate"
      />
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getCurrentTable"
          @size-change="getSizeTable"
        />
      </div>
    </el-card>
    <!-- 新增渠道 -->
    <el-dialog
      :visible.sync="addDialogVisible"
      width="600px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <template slot="title">
        <div>
          <span style="font-size: 18px">{{ titleName }}</span>
          <span v-if="operateType !== 0" class="versionChannel" @click="checkVersion(detailData)">{{ detailData.currentVersion }}</span>
        </div>
      </template>
      <addChannel
        ref="addChannelRef"
        :key="addChannelKey"
        :detail-data="detailData"
        :operate-type="operateType"
        :channel-option="channelOption"
        @tableUpdate="tableUpdate"
      />
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addDialogVisible = false">{{ $t('GlobalSetObj.cancel') }}</el-button>
        <el-button
          v-if="operateType !== 1" size="small" type="primary"
          @click="confirmAddChannel"
        >{{ $t('GlobalSetObj.confirm') }}</el-button>
      </div>
    </el-dialog>
    <!--历史版本-->
    <el-dialog
      :title="$t('ChannelManage.HistoryVersionDataQuery')"
      :visible.sync="versionDialogVisible"
      width="1000px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <versionData :key="historyKey" :version-data="detailData" />
    </el-dialog>
  </div>
</template>
<script>

import tableCmp from './cmp/tableCmp.vue';
import addChannel from './cmp/addChannel.vue';
import versionData from './cmp/versionData.vue';
import {
  channelVolumeConfigGetDetail,
  channelVolumeConfigGetPage,
  queryExpressChannelPrice
} from '@/api/finance/basicData';
export default {
  name: 'ChannelVolume',
  components: {
    tableCmp,
    addChannel,
    versionData
  },
  data() {
    return {
      queryForm: {
        pageNumber: 1,
        pageSize: 20,
        params: {
          channelValue: null,
          status: null
        }
      },
      tableData: [],
      total: 0,
      tableKey: new Date().getTime(),
      addDialogVisible: false,
      addChannelKey: new Date().getTime(),
      detailData: null,
      operateType: 0,
      titleName: null,
      versionDialogVisible: false,
      channelOption: [],
      historyKey: new Date().getTime()
    };
  },
  created() {
    this.getChannelOption();
    this.search();
  },
  methods: {
    // 查看历史版本
    checkVersion(data) {
      this.detailData = data;
      this.historyKey = new Date().getTime();
      this.versionDialogVisible = true;
    },
    // 确定新增渠道
    confirmAddChannel() {
      this.$refs.addChannelRef.confirmAddChannel();
    },
    // 打开新增渠道弹窗
    addChannelData(row = null, type = 0) {
      this.operateType = type;
      if (type === 0) {
        this.titleName = this.$t('GlobalSetObj.add');
      } else if (type === 1) {
        this.titleName = this.$t('GlobalSetObj.details');
      } else if (type === 2) {
        this.titleName = this.$t('ChannelManage.iteration');
      }
      if (type !== 0) {
        channelVolumeConfigGetDetail(row.id).then(res => {
          if (res.code === 200) {
            this.detailData = res.data;
            this.addChannelKey = new Date().getTime();
          }
        });
      }
      this.addChannelKey = new Date().getTime();
      this.addDialogVisible = true;
    },
    // 获取渠道选项
    getChannelOption() {
      queryExpressChannelPrice({
        dictCode: 'customer_channel'
      }).then(res => {
        if (res.code === 200) {
          this.channelOption = res.data;
        }
      });
    },
    // 搜索
    search() {
      this.queryForm.pageNumber = 1;
      this.getListData();
    },
    // 重置
    onReset() {
      this.queryForm = {
        pageNumber: 1,
        pageSize: 20,
        params: {
          channelValue: null,
          status: null
        }
      };
      this.getListData();
    },
    // 获取列表数据
    getListData() {
      const param = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: this.queryForm.params
      };
      channelVolumeConfigGetPage(param).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.tableKey = new Date().getTime();
        }
      });
    },
    // 操作
    tableUpdate(type) {
      if (type) {
        this.getListData();
      }
      this.addDialogVisible = false;
    },
    // 翻页
    getCurrentTable(val) {
      this.queryForm.pageNumber = val;
      this.getListData();
    },
    // 每页显示数量更改
    getSizeTable(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getListData();
    }
  }
};
</script>

<style scoped>
.versionChannel {
  border: 1px solid #0ca040;
  padding: 5px 15px;
  border-radius: 20px;
  color: #0ca040;
  margin-left: 20px;
  font-weight: normal;
  cursor: pointer;
}
</style>
